import React, {useState} from 'react';
import {Button, Modal, Row, Spin} from "antd";
import '../modals.css';
import {Redirect} from "react-router-dom";
import i18n from "../../../i18n";

export default function ModalNeedAuth({isShow, setIsShow, text, title = i18n.t('modals.modalNeedAuth.titles.default'), setStopListUpdate}) {

  const [loading, setLoading] = useState(false);
  const [redirectToAuth, setRedirectToAuth] = useState(false);

  const bigButtonStyle = {
    width: '200px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px'
  };

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };

  const redirect = () => {
    setRedirectToAuth(true);
  };

  if (redirectToAuth) {
    return (<Redirect to="/register" push={true}/>)
  }

  return (
    <Modal
      title={<span className="ant-modal-title">{title}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
        setStopListUpdate(false);
      }}
      footer={[
        <Button htmlType="submit" style={bigButtonStyle} key="submit" type="primary" onClick={() => {
          redirect()
        }}>{i18n.t('modals.modalNeedAuth.buttons.reg')}</Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered">
          <h2 style={textStyle}>{text}</h2>
        </Row>
      </Spin>
    </Modal>
  );
}
